const revenueBudget = {
    production: {
        amount:0,
        currency:""
    },
    lifetime: {
        amount:0,
        currency:""
    },
    weekend: {
        endDate: "",
        amount:0,
        currency:""
    },
    worldwide: {
        amount:0,
        currency:""
    }
}

export default revenueBudget;